import { onBeforeUnmount, onMounted, provide, watch, ref } from 'vue'
import { useConfiguration } from './useConfiguration.pinia'
import { provideContextSpecifics } from './useContextSpecifics'
import { useQuasar } from 'quasar'
import { useCustomStylesheet } from '@wilken8/portal-ui-common/composables/useCustomStylesheet'
import { useCustomIcons } from '@wilken8/portal-ui-common/composables/useCustomIcons'

export const useContextApplication = ({ contextOptions, mergeMessages, isMfe = false, loadConfiguration }) => {
  const { contextName } = provideContextSpecifics(contextOptions)
  const timeLog = `Context ${contextName} setup`
  console.time(timeLog)

  const loaded = ref(false)
  const q = useQuasar()
  const synced = ref(false)
  let timeout = null
  const isMinTimeUp = ref(false)
  const isConfigurationReady = ref(false)

  provide('contextName', contextName)

  onMounted(() => {
    setTimesUp()
  })

  onBeforeUnmount(() => {
    clearTimeout(timeout)
  })

  watch(isMinTimeUp, (val) => {
    if (val && isConfigurationReady.value && !loaded.value) loaded.value = true
  })

  const { brandConfig, loadRequiredConfiguration } = useConfiguration(loadConfiguration)

  loadRequiredConfiguration()
    .then(() => {
      mergeMessages(brandConfig.value.get('i18n') || {})
    })
    .then(() => {
      const { iconMapFn } = useCustomIcons({ config: brandConfig.value, loadIcons: !isMfe })

      if (!isMfe) {
        useCustomStylesheet({
          href: '__publicPath__/resources/css/style.css',
          onloadFn: () => window.onResourcesLoaded()
        })
      }

      q.iconMapFn = iconMapFn
    })
    .then(() => {
      isConfigurationReady.value = true
      if (isMinTimeUp.value) {
        loaded.value = true
      }
      console.timeEnd(timeLog)
    }).catch(e => {
      console.error(e)
    })

  function setSynced (val) {
    synced.value = val
  }

  function resetMinTimeUp () {
    isMinTimeUp.value = false
    setTimesUp()
  }

  async function setTimesUp () {
    return new Promise(() => {
      timeout = setTimeout(() => {
        isMinTimeUp.value = true
      }, 1500)
    })
  }

  return { loaded, synced, resetMinTimeUp, setSynced }
}
